import React,{useState} from 'react'
import '../styles/map.css'
import MapPage from '../img/ff.jpg'
import MapPage2 from '../img/ff.jpeg'
import {Helmet} from "react-helmet";

const MapPagee = () =>{
  const [ZoomValue,setZoomValue] = useState(0);
  const [image,setImage] = useState(false)
  return(
    <section className='map'>
      <Helmet>
      <title>Maps</title>
    <meta name="description" content='here you can create a new photos map '/>
  <meta name='keywords' content='map,pinweelo map,enveraworld website,map page'/>
   <link rel="canonical" href="https://pinweelo.com/maps" />
      </Helmet>
<div><img style={{width: 1000 + ZoomValue,height: 700 + ZoomValue}} alt="map" src={image?MapPage2:MapPage}/></div>
<div>

  <button onClick={()=> setZoomValue(prev => prev +  100)}>+</button>
<button onClick={()=> setZoomValue(prev => prev -  100)}>-</button>
<button onClick={()=> setZoomValue(prev => prev -  100)}>add Photo</button>
<button onClick={()=> setZoomValue(prev => prev -  100)}>delete Photo</button>
<button onClick={()=> setZoomValue(prev => prev -  100)}>add line</button>
<button onClick={()=> setImage(prev => !prev)}>change map</button>
</div>
    </section>
  )
}
export default MapPagee;
